import { createEntityAdapter } from '@reduxjs/toolkit';

export const entitiesAdapter = createEntityAdapter();



// WEBPACK FOOTER //
// ./src/store/common/adapter.js